(function () {
  function parseEndDate(dateStr) {
    if (!dateStr) return null;
    var endDate = dateStr.indexOf('T') > -1 ? new Date(dateStr) : new Date(dateStr + 'T23:59:00');
    if (Number.isNaN(endDate.getTime())) return null;
    return endDate;
  }

  function formatValue(value, pad) {
    return pad ? String(value).padStart(2, '0') : String(value);
  }

  function getExpiredMode(root) {
    var expiredMode = root.getAttribute('data-countdown-expired');
    if (expiredMode) return expiredMode;
    if (root.hasAttribute('data-show-at-zero')) {
      return root.getAttribute('data-show-at-zero') === 'true' ? 'show-zero' : 'hide';
    }
    return 'hide';
  }

  function initCountdown(root) {
    if (root.dataset.amCountdownInitialized === 'true') return;
    root.dataset.amCountdownInitialized = 'true';

    var endDate = parseEndDate(root.getAttribute('data-countdown-date'));
    if (!endDate) return;

    var daysEl = root.querySelector('[data-countdown-days]');
    var hoursEl = root.querySelector('[data-countdown-hours]');
    var minutesEl = root.querySelector('[data-countdown-minutes]');
    var secondsEl = root.querySelector('[data-countdown-seconds]');
    if (!daysEl && !hoursEl && !minutesEl && !secondsEl) return;

    var expiredMode = getExpiredMode(root);
    var pad = root.getAttribute('data-countdown-pad') === 'true';
    var hideTarget = root.getAttribute('data-countdown-hide-target');

    function setValues(days, hours, minutes, seconds) {
      if (daysEl) daysEl.textContent = formatValue(days, pad);
      if (hoursEl) hoursEl.textContent = formatValue(hours, pad);
      if (minutesEl) minutesEl.textContent = formatValue(minutes, pad);
      if (secondsEl) secondsEl.textContent = formatValue(seconds, pad);
    }

    function handleExpired() {
      if (expiredMode === 'show-zero') {
        setValues(0, 0, 0, 0);
        return;
      }

      if (expiredMode === 'hide-target' && hideTarget) {
        var target = document.querySelector(hideTarget);
        if (target) target.style.display = 'none';
        return;
      }

      root.hidden = true;
    }

    function updateCountdown() {
      var timeRemaining = endDate.getTime() - Date.now();

      if (timeRemaining <= 0) {
        handleExpired();
        clearInterval(timer);
        return;
      }

      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      setValues(days, hours, minutes, seconds);
    }

    updateCountdown();
    var timer = setInterval(updateCountdown, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-am-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
